import { getContext, put, select } from 'redux-saga/effects';

export function* updateConstraint(fieldName, constraintType, shouldAdd = true) {
    const { selectors, actions } = yield getContext('ctx');
    const constraints = yield select(selectors.getDataFieldConstraints, fieldName);

    const initialConstraint = yield select(
        selectors.getDataFieldInitialConstraintByType,
        fieldName,
        constraintType,
    );

    let updatedConstraints = constraints.filter(({ type }) => type !== constraintType);
    if (shouldAdd && initialConstraint) {
        updatedConstraints = [...updatedConstraints, initialConstraint];
    }

    yield put(actions.updateConstraints({ updatedFieldName: fieldName, updatedConstraints }));
}
